// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JobFolderAccordion > button {
  padding-left: 32px;
  padding-right: 32px;
}
.JobFolderAccordion > div {
  padding-left: 32px;
  padding-right: 32px;
}
.JobFolderAccordion-content {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  margin: 0;
  padding: 0;
}
.JobFolderAccordion-content > li {
  margin: 8px 0;
}
.JobFolderAccordion > button:hover {
  background-color: #F6F0FF;
  background-color: var(--color_primary_100, #F6F0FF);
}
.JobFolderAccordion > button:hover .JobTitle-title {
  color: var(--color_primary_500);
}
.JobFolderAccordion.expanded:hover .NewFolderInput-limit {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/JobFolderAccordion/styles.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,mBAAA;AADJ;AAIE;EACE,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EACA,SAAA;EACA,UAAA;AAFJ;AAII;EACE,aAAA;AAFN;AAME;EACE,yBAAA;EAAA,mDAAA;AAJJ;AAMI;EACE,+BAAA;AAJN;AASI;EACE,UAAA;AAPN","sourcesContent":[".JobFolderAccordion {\n  & > button {\n    padding-left: 32px;\n    padding-right: 32px;\n  }\n\n  & > div {\n    padding-left: 32px;\n    padding-right: 32px;\n  }\n\n  &-content {\n    appearance: none;\n    margin: 0;\n    padding: 0;\n\n    & > li {\n      margin: 8px 0;\n    }\n  }\n\n  & > button:hover {\n    background-color: var(--color_primary_100, #F6F0FF);\n\n    .JobTitle-title {\n      color: var(--color_primary_500);\n    }\n  }\n\n  &.expanded:hover {\n    .NewFolderInput-limit {\n      opacity: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
